// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/fonts/Sofia-Pro-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "LatoBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "RobotoMedium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "SofiaProMedium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

body {
  margin: 0;
}
@keyframes floating-heart {
  0% {
    opacity: 0;
    bottom: 0%;
    /* right: 0%; */
    transform: rotate(5deg);
  }
  10% {
    opacity: 1;
    bottom: 20%;
    /* right: 70%; */
    transform: rotate(-5deg);
  }
  20% {
    bottom: 40%;
    /* right: 20%; */
    transform: rotate(5deg);
  }
  30% {
    bottom: 60%;
    /* right: 60%; */
    transform: rotate(-5deg);
  }
  40% {
    opacity: 1;
    bottom: 80%;
    /* right: 30%; */
    transform: rotate(5deg);
  }
  48% {
    opacity: 0;
    bottom: 100%;
    /* right: 50%; */
    transform: rotate(-5deg);
  }
  100% {
    opacity: 0;
    bottom: 100%;
    /* right: 80%; */
    display: none;
    transform: rotate(5deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,+DAA4D;AAC9D;;AAEA;EACE,2BAA2B;EAC3B,+DAAgE;AAClE;;AAEA;EACE,6BAA6B;EAC7B,+DAAmE;AACrE;;AAEA;EACE,SAAS;AACX;AACA;EACE;IACE,UAAU;IACV,UAAU;IACV,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;AACF","sourcesContent":["@font-face {\n  font-family: \"LatoBold\";\n  src: url(\"../public/fonts/Lato-Bold.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"RobotoMedium\";\n  src: url(\"../public/fonts/Roboto-Medium.ttf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"SofiaProMedium\";\n  src: url(\"../public/fonts/Sofia-Pro-Medium.ttf\") format(\"truetype\");\n}\n\nbody {\n  margin: 0;\n}\n@keyframes floating-heart {\n  0% {\n    opacity: 0;\n    bottom: 0%;\n    /* right: 0%; */\n    transform: rotate(5deg);\n  }\n  10% {\n    opacity: 1;\n    bottom: 20%;\n    /* right: 70%; */\n    transform: rotate(-5deg);\n  }\n  20% {\n    bottom: 40%;\n    /* right: 20%; */\n    transform: rotate(5deg);\n  }\n  30% {\n    bottom: 60%;\n    /* right: 60%; */\n    transform: rotate(-5deg);\n  }\n  40% {\n    opacity: 1;\n    bottom: 80%;\n    /* right: 30%; */\n    transform: rotate(5deg);\n  }\n  48% {\n    opacity: 0;\n    bottom: 100%;\n    /* right: 50%; */\n    transform: rotate(-5deg);\n  }\n  100% {\n    opacity: 0;\n    bottom: 100%;\n    /* right: 80%; */\n    display: none;\n    transform: rotate(5deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
